import { http, setHTTPHeader } from './http.service';
import { IUserLogin, IRegisterUser } from '@/types/general';
import { login, logout, register } from '@/apis/auth.api';

class AuthService {
  async login(user: IUserLogin) {
    return login(user).then((response) => {
      console.log('Login response headers:', response.headers);
      if (response.headers.authorization) {
        const token = response.headers.authorization;
        console.log('Token found:', token);
        localStorage.setItem('user', JSON.stringify(response.data));
        localStorage.setItem('token', token);
        setHTTPHeader({ Authorization: token });
      } else {
        console.error('No authorization header found in login response');
      }

      return response.data;
    });
  }

  async logout() {
    try {
      await logout();
    } catch (error) {
      console.error('Logout API failed', error);
    } finally {
      // Clear HTTP headers
      delete http.defaults.headers.common['Authorization'];

      // Clear all auth-related data
      this.clearCache();

      // Clear any session storage
      sessionStorage.clear();

      // Clear all cookies
      document.cookie.split(';').forEach((cookie) => {
        const [name] = cookie.trim().split('=');
        document.cookie = `${name}=; expires=Thu, 01 Jan 1970 00:00:00 UTC; path=/;`;
      });

      // Force a hard redirect to clear the Vuex store and prevent back button access
      window.location.replace('/login');
    }
  }

  async register(user: IRegisterUser) {
    return register(user);
  }

  clearCache(): void {
    localStorage.clear();

    // if ('caches' in window) {
    //   caches.keys().then(cacheNames => {
    //     cacheNames.forEach(cacheName => {
    //       caches.delete(cacheName);
    //     });
    //   });
    // }

    // if ('serviceWorker' in navigator) {
    //   navigator.serviceWorker.getRegistrations().then(registrations => {
    //     registrations.forEach(registration => {
    //       registration.unregister();
    //     });
    //   });
    // }
  }

  getUser() {
    const user = localStorage.getItem('user');

    if (user) {
      try {
        return JSON.parse(user);
      } catch {
        return null;
      }
    }

    return null;
  }

  getToken() {
    return localStorage.getItem('token');
  }
}

const instance = new AuthService();

export default instance;
